/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-interface */
/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at Sat May 06 2023
 **/

import { Fragment, useCallback } from "react";

import { Configure } from "@/frameworks/libraries/utilities";

import { VoiceCallProvider } from "../voicecall";
import ChatSearchProvider from "./ChatSearchProvider";

function ChatProviderWithAuthenticated() {
	return (
		<>
			<VoiceCallProvider />
			<ChatSearchProvider />
		</>
	);
}

export default function ChatProvider() {
	const Provider = Configure.is_authenticated ? ChatProviderWithAuthenticated : Fragment;
	return <Provider />;
}
